import { PickemJoinGroupForm } from "components/Group/JoinGroup/PickemJoinGroupForm";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";

export const PickemJoinGroupPage = () => {
  return (
    <SingleColumnPage>
      <Panel type="information" padding="padded">
        <span>
          Join a group to compete and enjoy all that Pick'em has to offer with
          your community. Groups will use your regular picks that are also used
          in the global leaderboard, but is a convenient way to see a ranking
          amongst your community.
        </span>
      </Panel>
      <Panel header="Join A Pickem Group">
        <PickemJoinGroupForm />
      </Panel>
    </SingleColumnPage>
  );
};
